import { isGiftingPages } from 'Utils/Path';
import { getUrlParam } from 'Utils/Content';
import { clearEntitlements, getEntitlements } from './User';
import { clearSubscription } from './Subscriptions';
import { clearPaymentMethods } from './PaymentMethods';
import { clearPaymentHistory } from './Payments';
import { clearPlans } from './Plans';
import { fetchEventState, resetPurchaseMode } from './PurchaseMode';
import { resetPromoCode } from './PromoCode';
import { clearCheckout } from './Checkout';
import { launchAmplitude } from 'Utils/Analytics/Amplitude';
import { createProfile } from 'Utils/ProfileSDK';
import { createAuthInstance } from 'Utils/AuthSDK';
import { loadHeap } from 'Utils/Analytics/Heap';
import { initBraze } from 'Utils/Braze';
import { getState } from 'Utils/Store';
import { checkBangoParams, clearIntegrations } from './Integrations';
import { resetSecondScreen } from './SecondScreen';

const isGiftingMode = getUrlParam('gifting', false);

const locationPath = (window && window.location && window.location.pathname) || '';
const isGiftingRelatedPage = isGiftingMode || isGiftingPages(locationPath);

export const appInit = async () => {
  const state = getState();
  const {
    user: { isAuthenticated, profileId },
  } = state;

  createProfile();
  createAuthInstance();

  initBraze(profileId);

  await Promise.all([
    fetchEventState(isGiftingRelatedPage),
    checkBangoParams(),
    launchAmplitude(),
    (async () => {
      if (isAuthenticated) {
        await getEntitlements(1);
      }
    })(),
  ]);

  loadHeap();
};

export const clearAll = () => {
  clearPaymentMethods();
  clearPaymentHistory();
  clearSubscription();
  clearEntitlements();
  resetPromoCode();
  resetPurchaseMode();
  clearPlans();
  clearCheckout();
  clearIntegrations();
  resetSecondScreen();
};
